import { StyleSheet } from 'aphrodite';

// tslint:disable:object-literal-key-quotes

export const styleSheet = StyleSheet.create({
	container: {
	},
	hawksoftLogo: {
		backgroundSize: 'contain',
		marginLeft: 40,
		maxWidth: '50%',
		width: 330,
	},
	logoContainer: {
		alignItems: 'center',
		display: 'flex',
		margin: '0 auto',
		padding: '0 20px',
	},
});
